import React from "react";
import SearchContainer from "./SearchContainer/Index";
import PatientsReportTable from "./PatientsReportTable";

const OrderEntry = () => {
  return (
    <div>
      <PatientsReportTable />
    </div>
  );
};

export default OrderEntry;
